import fetch from './fetch';

// 订单管理
const getOrderList = params => fetch({ url: '/order_list', params });
const getOrderInfo = ({ params }) => fetch({ url: '/get_order', params });
const orderDetail = ({ params, id }) => fetch({ url: `/order_detail/${id}`, params });
const getClassList = ({ params }) => fetch({ url: '/get_class_list', params });

// 退款
const getRefundList = params => fetch({ url: '/refund_list', params });
const getRefund = ({ params }) => fetch({ url: '/get_refund', params });
const refundDetail = ({ params, id }) => fetch({ url: `/refund_detail/${id}`, params });
const agreeRefund = ({ id }) => fetch({ url: `/agree_refund/${id}`, methold: 'post' });
const accomplishRefund = ({ id, params }) => fetch({ url: `/accomplish_refund/${id}`, methold: 'post', params });
const refuseRefund = ({ id }) => fetch({ url: `/reject_refund/${id}`, methold: 'post' });
const getPayType = () => fetch({ url: '/get_pay_type' });
const getPayStatus = () => fetch({ url: '/get_pay_status' });
const getObjectType = () => fetch({ url: '/get_object_type' });
const applyRefund = ({ sign_up_id, params }) => fetch({ url: `/apply_refund/${sign_up_id}`, methold: 'post', params });

const getRefundFee = ({ sign_up_id, class_id }) =>
  fetch({ url: '/get_refund_fee_detail', params: { sign_up_id, class_id } });
const refundCategory = () => fetch({ url: '/refund_category' });
// 退费补费
const getSupplyFee = params => {
  const temp = {};
  Object.keys(params).map(key => {
    if (params[key] !== '-1') {
      temp[key] = params[key];
    }
    return key;
  });
  if (temp.supply_fee_status === '-1') delete temp.supply_fee_status;
  return fetch({ url: '/supply_fee', params: temp });
};
const addSupplyFee = ({ params }) => fetch({ url: '/supply_fee', params, methold: 'post' });
const refundSupplyFee = ({ params, supply_fee_id }) =>
  fetch({ url: `/supply_fee/${supply_fee_id}/refund_supply_fee`, params, methold: 'post' });
const payByBash = ({ record_id }) => fetch({ url: `/supply_fee/${record_id}/pay_by_cash`, methold: 'patch' });
const payByPos = ({ record_id }) => fetch({ url: `/supply_fee/${record_id}/pay_by_pos`, methold: 'patch' });
const supplyFeeReject = ({ record_id }) => fetch({ url: `/supply_fee/${record_id}/reject`, methold: 'patch' });
const supplyFeePrint = ({ record_id }) => fetch({ url: `/supply_fee/${record_id}/print_invoice`, methold: 'patch' });
const supplyStatus = () => fetch({ url: '/supply_fee_status' });
const supplyMethod = () => fetch({ url: '/supply_fee_method' });

// 薪酬管理
const allTeacherSalary = params => fetch({ url: '/all_teacher_salary_list', params });
const createPayroll = ({ params }) => fetch({ url: '/create_payroll', params, methold: 'post' });
const queryPayroll = params => fetch({ url: '/query_payroll', params });
const verifyBill = ({ params }) =>
  fetch({
    url: '/verify_bill',
    params,
    isFull: true,
    config: { responseType: 'blob' }
  });
const revenueStatistics = params => fetch({ url: '/revenue_statistics', params });
const querySubstituteClass = ({ params }) => fetch({ url: '/query_substitute_class_info', params });
const queryMyPayroll = params => fetch({ url: '/query_my_payroll_list', params });
// 缴费管理
const paymentQuery = params => fetch({ url: '/payment_query', params });
const discountQuery = params => fetch({ url: '/discount_query', params });

// 导出
const exportOrder = ({ params }) =>
  fetch({
    url: '/export_order_list',
    params,
    isFull: true,
    config: { responseType: 'blob' }
  });
const exportRefund = ({ params }) =>
  fetch({
    url: '/export_refund_list',
    params,
    isFull: true,
    config: { responseType: 'blob' }
  });
const exportPayment = ({ params }) =>
  fetch({
    url: '/export_payment_list',
    params,
    isFull: true,
    config: { responseType: 'blob' }
  });
const exportDiscount = ({ params }) =>
  fetch({
    url: '/export_discount_list',
    params,
    isFull: true,
    config: { responseType: 'blob' }
  });
const exportRefundDetail = ({ params }) =>
  fetch({
    url: '/export_refund_list',
    params,
    isFull: true,
    config: { responseType: 'blob' }
  });
// 发票
const invoiceList = params => fetch({ url: '/get_invoice_list', params });
const controlInvoice = ({ id }) => fetch({ url: `/change_invoice_status/${id}`, methold: 'put' });
const invoiceStatus = () => fetch({ url: '/invoice_status' });
const getFeeDetails = ({ params }) => fetch({ url: '/get_fee_details', params });

const applyRefundSupplyFee = ({ sign_up_id, params }) =>
  fetch({ url: `/apply_refund_supply_fee_remains/${sign_up_id}`, methold: 'post', params });
const refundRecord = params => fetch({ url: `/refund_record_list/${params.sign_up_id}`, params });
const supplyFee = params => fetch({ url: `/supply_fee_list/${params.sign_up_id}`, params });
const batchSupplyFee = ({ params }) => fetch({ url: '/batch_supply_fee', params, methold: 'post' });

const auditRefund = params => fetch({ url: `/audit_refund_list/${params.sign_up_id}` });
const alreadyRefund = params => fetch({ url: `/already_refund_list/${params.sign_up_id}` });
const auditSupplyFee = params => fetch({ url: `/audit_supply_fee_list/${params.sign_up_id}` });
const alreadySupply = params => fetch({ url: `/already_supply_fee_list/${params.sign_up_id}` });

const refundFeeList = params => fetch({ url: '/refund_list', params });
const refundStatus = () => fetch({ url: '/refund_status_select' });

const getSupplyFeeRefundDetail = ({ params }) =>
  fetch({ url: `get_supply_fee_refund_detail/${params.supply_fee_id}`, params });
const refundApplyDetail = ({ record_id }) => fetch({ url: `/refund_apply_detail/${record_id}` });

const signUpPurchaseStatistics = params => fetch({ url: '/sign_up_purchase_statistics', params });

const orgQuery = () => fetch({ url: '/sign_up_purchase_statistics/org_query' });
const rootSpecializedSubjectQuery = ({ org_id }) =>
  fetch({ url: `/sign_up_purchase_statistics/root_specialized_subject_query/${org_id}` });
const specializedSubjectQuery = ({ org_id, root_specialized_subject_id }) =>
  fetch({ url: `/sign_up_purchase_statistics/specialized_subject_query/${org_id}/${root_specialized_subject_id}` });

const teacherSalaryDetail = ({ params }) => fetch({ url: '/teacher_salary_detail', params });

const exportTeacherSalary = ({ params }) =>
  fetch({
    url: '/export_teacher_salary_detail',
    params,
    isFull: true,
    config: { responseType: 'blob' }
  });
const exportSignUpPurchase = ({ params }) =>
  fetch({
    url: '/export_sign_up_purchase_statistics',
    params,
    isFull: true,
    config: { responseType: 'blob' }
  });
const signUpStatusList = () => fetch({ url: '/sign_up_status_list' });
const transferRecord = params => fetch({ url: '/transfer_class_record_query', params });

const submitRefund = ({ params }) => fetch({ url: '/batch_apply_refund', methold: 'post', params });
const refundDetailList = params => fetch({ url: '/batch_refund_detail', params });

const refundRequestList = params => fetch({ url: '/activity_apply_refund_list', params });
const refundRequest = ({ id, params }) => fetch({ url: `/activity_apply_refund/${id}`, methold: 'post', params });
const exportTransferRecord = ({ params }) => fetch({
  url: '/export_transfer_class_record',
  params,
  isFull: true,
  config: { responseType: 'blob' }
});
export default {
  transferRecord,
  exportSignUpPurchase,
  exportTeacherSalary,
  teacherSalaryDetail,
  rootSpecializedSubjectQuery,
  specializedSubjectQuery,
  orgQuery,
  signUpPurchaseStatistics,
  refundApplyDetail,
  getSupplyFeeRefundDetail,
  refundStatus,
  refundFeeList,
  alreadySupply,
  auditRefund,
  alreadyRefund,
  auditSupplyFee,
  batchSupplyFee,
  refundRecord,
  supplyFee,
  applyRefundSupplyFee,
  refundCategory,
  getRefundFee,
  getFeeDetails,
  applyRefund,
  refundSupplyFee,
  addSupplyFee,
  supplyMethod,
  supplyStatus,
  supplyFeePrint,
  supplyFeeReject,
  payByPos,
  getSupplyFee,
  payByBash,
  invoiceList,
  controlInvoice,
  invoiceStatus,
  getOrderList,
  getOrderInfo,
  orderDetail,
  getClassList,
  getRefundList,
  getRefund,
  refundDetail,
  agreeRefund,
  accomplishRefund,
  refuseRefund,
  allTeacherSalary,
  createPayroll,
  queryPayroll,
  getPayType,
  getObjectType,
  verifyBill,
  getPayStatus,
  revenueStatistics,
  querySubstituteClass,
  paymentQuery,
  discountQuery,
  queryMyPayroll,
  exportOrder,
  exportRefund,
  exportPayment,
  exportDiscount,
  exportRefundDetail,
  signUpStatusList,
  refundDetailList,
  submitRefund,
  refundRequestList,
  refundRequest,
  exportTransferRecord
};
